import { VISITOR_HEADER } from '@/constants/book';
import { BookInfo } from '@/types/book';
import { comma } from '@/util/format';
import { Icon } from '@successmode-ktp/kui';
import { format } from 'date-fns';
import styled from 'styled-components';

type Props = {
  row?: BookInfo[];
};

function VisitorTable({ row }: Props) {
  const data =
    row?.map((item) => {
      return {
        applyTime: format(new Date(item.applyTime), 'yyyy-MM-dd HH:mm'),
        nation: item.nation,
        gender: item.gender === 'M' ? '남' : item.gender === 'F' ? '여' : '-',
        birth: item.birthYear,
        name: item.name,
        companions: item.companions,
        contactCannel: `${item.channel} ${item.email}`,
        reservationTime: format(
          new Date(item.reservationTime),
          'yyyy-MM-dd HH:mm',
        ),
        bookStatus: item.reservationStatus,
      };
    }) || [];

  return (
    <Table>
      <colgroup>
        <col width='15%' />
        <col width='4%' />
        <col width='4%' />
        <col width='5%' />
        <col width='auto' />
        <col width='4%' />
        <col width='15%' />
        <col width='386px' />
      </colgroup>
      <Thead>
        <Tr>
          {VISITOR_HEADER.map(({ type, label }) => (
            <Th key={type}>{label}</Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {data.length > 0 ? (
          data.map((item, index) => (
            <Tr key={index}>
              <Td>{item.applyTime}</Td>
              <Td>{item.nation}</Td>
              <Td>{item.gender}</Td>
              <Td>{item.birth}</Td>
              <Td style={{ wordBreak: 'break-all' }}>{item.name}</Td>
              <Td>{comma(item.companions || 1)}명</Td>
              <Td>{item.reservationTime}</Td>
              <Td>
                <StatusList>
                  <Status selected={item.bookStatus === 'RESERVED'}>
                    예약 접수
                  </Status>
                  <Icon.ChevronRight fillColor='#949494' size={18} />
                  <Status selected={item.bookStatus === 'CONFIRMED'}>
                    예약 확정
                  </Status>
                  <Icon.ChevronRight fillColor='#949494' size={18} />
                  <Status selected={item.bookStatus === 'COMPLETED'}>
                    방문 완료
                  </Status>
                </StatusList>
              </Td>
            </Tr>
          ))
        ) : (
          <NoResult colSpan={9}>
            <NoResultMessage>접수된 예약 내역이 없습니다</NoResultMessage>
          </NoResult>
        )}
      </Tbody>
    </Table>
  );
}

const Table = styled.table`
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  border-style: hidden;
  border-collapse: collapse;
`;

const Thead = styled.thead`
  background-color: #e5e6e8;
  height: 52px;
`;

const Th = styled.th`
  color: #80848a;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  vertical-align: middle;
  padding: 8px;
  white-space: nowrap;
  border-bottom: 1px solid #a7a7a7;
`;

const Tbody = styled.tbody`
  background-color: #fff;
`;

const Tr = styled.tr`
  text-align: left;

  > *:first-child {
    padding-left: 20px;
  }
  > *:last-child {
    padding-right: 20px;
  }
`;

const Td = styled.td`
  padding: 8px;
  vertical-align: middle;
  border-bottom: 1px solid #e5e6e8;
`;

const StatusList = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Status = styled.span<{ selected: boolean }>`
  width: 106px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: ${({ selected }) => (selected ? '#00BFFF' : '#B7B7B7')};
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  background-color: ${({ selected }) => (selected ? '#E4F8FF' : '#F5F6F7')};
  border: 1px solid ${({ selected }) => (selected ? '#00BFFF' : '#B7B7B7')};
`;

const NoResult = styled.td`
  text-align: center;
  vertical-align: middle;
  height: 384px;
`;

const NoResultMessage = styled.span`
  color: #80848a;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  width: 310px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 12px;
  border: 1px dashed #cbccce;
`;

export default VisitorTable;
